import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import MoviePage from "@/MoviePage";
import App from "@/App";

function Router() {
  const [route, setRoute] = useState(window.location.pathname);

  useEffect(() => {
    const handlePop = () => setRoute(window.location.pathname);
    window.addEventListener("popstate", handlePop);
    return () => window.removeEventListener("popstate", handlePop);
  }, []);

  if (route === "/studio") {
    return <App />;
  }

  return <MoviePage />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);
